// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Header_toolbar__3oiOi","placeholder":"Header_placeholder__3zrTp","logo":"Header_logo__2XG30","sectionLink":"Header_sectionLink__rmffz","btnOne":"Header_btnOne__2tzlb"};